import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';
import cn from 'classnames';

import { ISubmitAnInquiryCTACardProps } from './SubmitAnInquiryCTACard.interface';

import './style.scss';

const SubmitAnInquiryCTACard: FC<ISubmitAnInquiryCTACardProps> = ({ className, link }) => {
  const { t } = useTranslation();

  return (
    <Box className={cn('submit-inquiry-cta', className)}>
      <p className="caption">{t('medicationLookup.notSeeingMed')}</p>

      <Button variant="text" href={link.href}>
        <span className="submit-inquiry-cta__button-text">
          {t('medicationLookup.submitAnInquiry')}
        </span>
      </Button>
    </Box>
  );
};

export default SubmitAnInquiryCTACard;
